//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { replaceSpecialCharacters } from '~/utils';
export default {
  name: 'JobItem',
  props: {
    item: { type: Object, default: () => {} },
    details: { type: Boolean, default: false },
    isFavorites: { type: Boolean, default: false },
    isApplication: { type: Boolean, default: false },
  },
  methods: {
    gotoJobsContent(item) {
      this.$router.push({
        path: `/JobsContent/${item.id}-${replaceSpecialCharacters(item.title)}`,
        query: { id: item.id },
      });
    },
    gotoCompany(id) {
      this.$router.push(`/Company/${id}`);
    },
    cancelFavorite(title, id) {
      this.$confirm(`是否取消收藏 ${title}？`, '提示', {
        type: 'warning',
      }).then(() => {
        this.$api('userRemoveFavoriteJob', {
          jobPositionId: id,
        }).then(() => {
          this.$message.success('取消收藏成功!');
          this.$emit('update');
        });
      });
    },
    cancelApply(title, id) {
      this.$confirm(`是否取消應徵 ${title}？`, '提示', {
        type: 'warning',
      }).then(() => {
        this.$api('cancelUserApplicant', { id }).then(() => {
          this.$message.success('取消應徵成功!');
          this.$emit('update');
        });
      });
    },
    replay(id) {
      console.log('🚀 ~ file: JobItem.vue ~ line 69 ~ replay ~ id', id);
    },
  },
};
